import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleUpSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-triangle-up-small, dropdown, caret"} maskId="square-filled-radius-0-stroke-1-IconChevronTriangleUpSmall"><path d="M7.91309 13.4997L12.0002 8.73145L16.0873 13.4997H7.91309Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronTriangleUpSmall;
